module.exports = __webpack_public_path__ + "static/media/mobile-security.d3c4fc7a.jpeg";